"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEmailLoginDto = instanceOfEmailLoginDto;
exports.EmailLoginDtoFromJSON = EmailLoginDtoFromJSON;
exports.EmailLoginDtoFromJSONTyped = EmailLoginDtoFromJSONTyped;
exports.EmailLoginDtoToJSON = EmailLoginDtoToJSON;
exports.EmailLoginDtoToJSONTyped = EmailLoginDtoToJSONTyped;
/**
 * Check if a given object implements the EmailLoginDto interface.
 */
function instanceOfEmailLoginDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('otp' in value) || value['otp'] === undefined)
        return false;
    return true;
}
function EmailLoginDtoFromJSON(json) {
    return EmailLoginDtoFromJSONTyped(json, false);
}
function EmailLoginDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'otp': json['otp'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'visitorId': json['visitorId'] == null ? undefined : json['visitorId'],
        'deviceFingerprint': json['deviceFingerprint'] == null ? undefined : json['deviceFingerprint'],
    };
}
function EmailLoginDtoToJSON(json) {
    return EmailLoginDtoToJSONTyped(json, false);
}
function EmailLoginDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'otp': value['otp'],
        'phone': value['phone'],
        'visitorId': value['visitorId'],
        'deviceFingerprint': value['deviceFingerprint'],
    };
}
